import Constants from './constants';
import BrowserCookies from './browserCookies';

function GetUrlParameterByName(name, url) {
  url = url || window.location.href;
  // eslint-disable-next-line no-useless-escape
  name = name.replace(/[\[\]]/g, '\\$&');
  const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(url);
  if (!results) {
    // Return null if query parameter does not exist
    return null;
  }
  if (!results[2]) {
    // Return "" if query paremeter has no value
    return '';
  }
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

function GetUserDefaultLocale() {
  const lang = navigator.userLanguage || navigator.language || navigator.browserLanguage;
  let language = Constants.Languages.English;
  if (Constants.Languages.English === lang.toLowerCase()) {
    language = Constants.Languages.English;
  } else if (Constants.Languages.Chinese === lang.toLowerCase()) {
    language = Constants.Languages.Chinese;
  } else if (Constants.Languages.Japanese === lang.toLowerCase()) {
    language = Constants.Languages.Japanese;
  }
  return language;
}

function GetPreferredLanguage() {
  let preferredLanguage = GetUrlParameterByName(Constants.UrlParameters.LanguagePreference);
  if (!preferredLanguage) {
    // eslint-disable-next-line max-len
    preferredLanguage = BrowserCookies.Get(Constants.Cookies.LanguagePreference) ? BrowserCookies.Get(Constants.Cookies.LanguagePreference) : GetUserDefaultLocale();
  }
  return preferredLanguage;
}

export {
  GetPreferredLanguage,
  GetUrlParameterByName,
};

export default GetPreferredLanguage;
